import { styled, Box, BoxProps } from '@withjoy/joykit';

export const StyledBox = styled(Box)<{ maxWidth: BoxProps['marginBottom'] }>`
  max-width: ${({ maxWidth }) => maxWidth};
`;
